import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import ButtonBase from '@mui/material/ButtonBase';
import { alpha, useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------

// The billing period as two pills, the chosen one raised. `checked` means
// yearly; `onChange` flips it (so it's only called on the other pill).
export default function PricingSwitch ({ checked, onChange }) {
  const theme = useTheme();

  const pill = (active) => ({
    gap: 1,
    px: 2.25,
    height: 40,
    borderRadius: 999,
    fontSize: '0.9375rem',
    fontWeight: 600,
    color: active ? 'text.primary' : 'text.secondary',
    bgcolor: active ? 'background.paper' : 'transparent',
    boxShadow: active ? `0 1px 2px ${alpha(theme.palette.grey[900], 0.08)}, 0 4px 12px -4px ${alpha(theme.palette.grey[900], 0.16)}` : 'none',
    transition: theme.transitions.create(['background-color', 'box-shadow', 'color'], { duration: 200 }),
    '&.Mui-focusVisible': { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
  });

  return (
    <Stack direction="row" justifyContent="center">
      <Box
        role="group"
        aria-label="Billing period"
        sx={{
          display: 'inline-flex',
          p: 0.5,
          gap: 0.5,
          borderRadius: 999,
          bgcolor: alpha(theme.palette.grey[500], 0.08),
          border: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
        }}
      >
        <ButtonBase aria-pressed={!checked} onClick={() => checked && onChange()} sx={pill(!checked)}>
          Monthly
        </ButtonBase>

        <ButtonBase aria-pressed={checked} onClick={() => !checked && onChange()} sx={pill(checked)}>
          Yearly
          <Box
            component="span"
            sx={{
              px: 1,
              py: 0.25,
              borderRadius: 999,
              fontSize: '0.75rem',
              fontWeight: 700,
              color: 'primary.dark',
              bgcolor: alpha(theme.palette.primary.main, 0.14),
            }}
          >
            2 months free
          </Box>
        </ButtonBase>
      </Box>
    </Stack>
  );
}

PricingSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
